"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[282],{

/***/ 80882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_DownOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(1413);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/DownOutlined.js
// This icon file is generated automatically.
var DownOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z" } }] }, "name": "down", "theme": "outlined" };
/* harmony default export */ var asn_DownOutlined = (DownOutlined);

// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 4 modules
var AntdIcon = __webpack_require__(42922);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/DownOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var DownOutlined_DownOutlined = function DownOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
    ref: ref,
    icon: asn_DownOutlined
  }));
};

DownOutlined_DownOutlined.displayName = 'DownOutlined';
/* harmony default export */ var icons_DownOutlined = (/*#__PURE__*/react.forwardRef(DownOutlined_DownOutlined));

/***/ }),

/***/ 48115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_UpOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(1413);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/UpOutlined.js
// This icon file is generated automatically.
var UpOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 00140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z" } }] }, "name": "up", "theme": "outlined" };
/* harmony default export */ var asn_UpOutlined = (UpOutlined);

// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 4 modules
var AntdIcon = __webpack_require__(42922);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/UpOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var UpOutlined_UpOutlined = function UpOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
    ref: ref,
    icon: asn_UpOutlined
  }));
};

UpOutlined_UpOutlined.displayName = 'UpOutlined';
/* harmony default export */ var icons_UpOutlined = (/*#__PURE__*/react.forwardRef(UpOutlined_UpOutlined));

/***/ }),

/***/ 10282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ MenuHeader_MenuHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/sunday-component/lib/index.js
var lib = __webpack_require__(58960);
// EXTERNAL MODULE: ./src/components/Common/Header/SundayLogo/SundayLogo.tsx
var SundayLogo = __webpack_require__(5671);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/UpOutlined.js + 1 modules
var UpOutlined = __webpack_require__(48115);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/DownOutlined.js + 1 modules
var DownOutlined = __webpack_require__(80882);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/antd/es/drawer/index.js + 5 modules
var drawer = __webpack_require__(84131);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./src/styles/globals.ts
var globals = __webpack_require__(60082);
;// CONCATENATED MODULE: ./src/components/Common/Header/MainMenu/SubMenuDrawer.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        " !important;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-shadow: none;\n  z-index: 20;\n  .ant-drawer-body {\n    padding: 0;\n    height: fit-content;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  height: 121px;\n  width: 100%;\n  margin: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 19px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  vertical-align: middle;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 1400px;\n\n  a {\n    color: #2a2c2e;\n  }\n  a * {\n    color: #2a2c2e;\n  }\n  a:hover {\n    color: #fa4616;\n  }\n  a:hover * {\n    color: #fa4616;\n  }\n  padding-top: 2.5rem;\n  line-height: 36px;\n  color: #76777a;\n\n  * {\n    color: #76777a;\n  }\n  ul {\n    padding-top: 1rem;\n    padding-left: 0;\n    margin-bottom: 2.5rem;\n    list-style-type: none;\n  }\n  li {\n    padding-top: 0.5rem;\n    list-style: none;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}







var Title = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).withConfig({
    componentId: "sc-b34bd25-0"
})(_templateObject(), globals/* color.charcoal10 */.$.charcoal10);
var DrawerContainer = (0,styled_components_browser_esm/* default */.ZP)(drawer/* default */.Z).withConfig({
    componentId: "sc-b34bd25-1"
})(_templateObject1());
var HorizontalDivider = styled_components_browser_esm/* default.hr.withConfig */.ZP.hr.withConfig({
    componentId: "sc-b34bd25-2"
})(_templateObject2());
var Submenu = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b34bd25-3"
})(_templateObject3());
var SubmenuContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b34bd25-4"
})(_templateObject4());
var SubMenuDrawer = function(param) {
    var visible = param.visible, onClose = param.onClose;
    var ref = (0,useTranslation/* useTranslation */.$)("layout"), t = ref.t, i18n = ref.i18n;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DrawerContainer, {
        closable: false,
        placement: "top",
        visible: visible,
        onClose: onClose,
        height: "660",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalDivider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Submenu, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubmenuContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                                span: 7,
                                offset: 3,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                        level: 5,
                                        children: t("header.healthInsurance.title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://retail.easysunday.com/".concat(i18n.language, "/health"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                                                        level: 7,
                                                        children: t("header.healthInsurance.lumpSum")
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://retail.easysunday.com/".concat(i18n.language, "/axa-child-health"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                                                        level: 7,
                                                        children: t("header.healthInsurance.child")
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://retail.easysunday.com/".concat(i18n.language, "/#accident"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                                                        level: 7,
                                                        children: t("header.healthInsurance.personalAccident")
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://retail.easysunday.com/".concat(i18n.language),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                                                        level: 7,
                                                        children: t("header.healthInsurance.allProducts")
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                        level: 5,
                                        children: t("header.motorInsurance.title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://retail.easysunday.com/".concat(i18n.language, "/sunday-car-insurance-ev"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                                                        level: 7,
                                                        children: t("header.motorInsurance.ev")
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://retail.easysunday.com/".concat(i18n.language, "/sunday-car-insurance"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                                                        level: 7,
                                                        children: t("header.motorInsurance.motor")
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://easysunday.com/".concat(i18n.language, "/motor"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                                                        level: 7,
                                                        children: t("header.motorInsurance.allProducts")
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://easysunday.com/".concat(i18n.language, "/motor/claim"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                                                        level: 7,
                                                        children: t("header.motorInsurance.claim")
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://sundayinsurance.co.th/".concat(i18n.language, "/services/panel/?type=garage"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                                                        level: 7,
                                                        children: t("header.motorInsurance.sundayPartner")
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                                span: 6,
                                offset: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                        level: 5,
                                        children: t("header.sundayHealthForBusiness.title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://easysunday.com/".concat(i18n.language, "/our-product/health/"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                                                        level: 7,
                                                        children: t("header.sundayHealthForBusiness.about")
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://easysunday.com/".concat(i18n.language, "/our-product/health/#owner"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                                                        level: 7,
                                                        children: t("header.sundayHealthForBusiness.forBusinessOwner")
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://easysunday.com/".concat(i18n.language, "/our-product/health/#employee"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                                                        level: 7,
                                                        children: t("header.sundayHealthForBusiness.forEmployee")
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://sundayinsurance.co.th/".concat(i18n.language, "/services/panel/?type=hospital-suncare"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                                                        level: 7,
                                                        children: t("header.sundayHealthForBusiness.sundayHospitalNetwork")
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                        level: 5,
                                        children: t("header.gadgetWarranty.title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "https://easysunday.com/".concat(i18n.language, "/warranty/"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                                                    level: 7,
                                                    children: t("header.gadgetWarranty.claim")
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var MainMenu_SubMenuDrawer = (SubMenuDrawer);

;// CONCATENATED MODULE: ./src/components/Common/Header/MainMenu/MainMenu.tsx
/* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable jsx-a11y/anchor-is-valid */ /* eslint-disable react/require-default-props */ /* eslint-disable @typescript-eslint/no-unused-vars */ 
function MainMenu_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media only screen and (max-width: 1100px) {\n    display: none;\n  }\n"
    ]);
    MainMenu_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MainMenu_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: 1rem;\n  font-size: 14px;\n"
    ]);
    MainMenu_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MainMenu_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n"
    ]);
    MainMenu_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function MainMenu_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 40px;\n  :last-of-type {\n    margin-right: 0px;\n  }\n"
    ]);
    MainMenu_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function MainMenu_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #2b2b2b;\n  :hover {\n    color: #ff875e;\n    cursor: pointer;\n  }\n"
    ]);
    MainMenu_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #2b2b2b;\n  :hover {\n    color: #ff875e;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  :hover {\n    color: #ff875e;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}







var MainMenuContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a38c14b-0"
})(MainMenu_templateObject());
var UpDownIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-1a38c14b-1"
})(MainMenu_templateObject1());
var MainMenuUl = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-1a38c14b-2"
})(MainMenu_templateObject2());
var MainMenuLi = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-1a38c14b-3"
})(MainMenu_templateObject3());
var MainMenuText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a38c14b-4"
})(MainMenu_templateObject4());
var MainMenuLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-1a38c14b-5"
})(_templateObject5());
var MainMenuBody = (0,styled_components_browser_esm/* default */.ZP)(lib.Body).withConfig({
    componentId: "sc-1a38c14b-6"
})(_templateObject6());
var MainMenu = function(param) {
    var subMenuVisible = param.subMenuVisible, setSubMenuVisible = param.setSubMenuVisible, menus = param.menus;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var ref10 = (0,useTranslation/* useTranslation */.$)("layout"), t = ref10.t, i18n = ref10.i18n;
    var triggerSubMenu = function() {
        return setSubMenuVisible(!subMenuVisible);
    };
    var closeSubMenu = function() {
        return setSubMenuVisible(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenuContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainMenuUl, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenuLi, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenuText, {
                                onClick: triggerSubMenu,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainMenuBody, {
                                    level: 5,
                                    children: [
                                        t("header.buyOnline"),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UpDownIcon, {
                                            children: subMenuVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(UpOutlined/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DownOutlined/* default */.Z, {})
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenuLi, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenuLink, {
                                href: (menus === null || menus === void 0 ? void 0 : (ref = menus.privilege) === null || ref === void 0 ? void 0 : ref.href) || "https://easysunday.com/".concat(i18n.language, "/privilege"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenuBody, {
                                    level: 5,
                                    children: (menus === null || menus === void 0 ? void 0 : (ref1 = menus.privilege) === null || ref1 === void 0 ? void 0 : ref1.label) || t("header.privilege")
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenuLi, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenuLink, {
                                href: (menus === null || menus === void 0 ? void 0 : (ref2 = menus.faq) === null || ref2 === void 0 ? void 0 : ref2.href) || "https://easysunday.com/".concat(i18n.language, "/faq"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenuBody, {
                                    level: 5,
                                    children: (menus === null || menus === void 0 ? void 0 : (ref3 = menus.faq) === null || ref3 === void 0 ? void 0 : ref3.label) || t("header.faq")
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenuLi, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenuLink, {
                                href: (menus === null || menus === void 0 ? void 0 : (ref4 = menus.blog) === null || ref4 === void 0 ? void 0 : ref4.href) || "https://easysunday.com/blog",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenuBody, {
                                    level: 5,
                                    children: (menus === null || menus === void 0 ? void 0 : (ref5 = menus.blog) === null || ref5 === void 0 ? void 0 : ref5.label) || t("header.blog")
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenuLi, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenuLink, {
                                href: (menus === null || menus === void 0 ? void 0 : (ref6 = menus.contactUs) === null || ref6 === void 0 ? void 0 : ref6.href) || "https://easysunday.com/".concat(i18n.language, "/contact-us"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenuBody, {
                                    level: 5,
                                    children: (menus === null || menus === void 0 ? void 0 : (ref7 = menus.contactUs) === null || ref7 === void 0 ? void 0 : ref7.label) || t("header.contactus")
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenuLi, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenuLink, {
                                href: (menus === null || menus === void 0 ? void 0 : (ref8 = menus.aboutUs) === null || ref8 === void 0 ? void 0 : ref8.href) || "https://about.easysunday.com",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenuBody, {
                                    level: 5,
                                    children: (menus === null || menus === void 0 ? void 0 : (ref9 = menus.aboutUs) === null || ref9 === void 0 ? void 0 : ref9.label) || t("header.about")
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenu_SubMenuDrawer, {
                visible: subMenuVisible,
                onClose: closeSubMenu
            })
        ]
    });
};
/* harmony default export */ var MainMenu_MainMenu = (MainMenu);

// EXTERNAL MODULE: ./src/components/Common/Header/MainMenu/MobileMainMenu.tsx
var MobileMainMenu = __webpack_require__(14461);
// EXTERNAL MODULE: ./node_modules/styled-breakpoints/index.js
var styled_breakpoints = __webpack_require__(94698);
;// CONCATENATED MODULE: ./src/components/Common/Header/MenuHeader/MenuHeader.style.tsx

function MenuHeader_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    MenuHeader_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MenuHeader_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 120px;\n  background-color: white;\n  position: relative;\n  border-bottom-style: solid;\n  border-bottom-width: 1px;\n  border-bottom-color: ",
        ";\n  z-index: 30;\n  @media only screen and (max-width: 767px) {\n    height: 56px;\n  }\n  @media only screen and (min-width: 992px) and (max-width: 1199px) and (orientation: portrait) {\n    height: 56px;\n  }\n  @media only screen and (min-width: 768px) and (max-width: 991px) {\n    height: 56px;\n  }\n"
    ]);
    MenuHeader_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MenuHeader_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  justify-content: space-between;\n"
    ]);
    MenuHeader_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function MenuHeader_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    MenuHeader_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function MenuHeader_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    MenuHeader_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function MenuHeader_style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: fit-content;\n  margin-right: 72px;\n  ",
        " {\n    margin: 0px;\n  }\n"
    ]);
    MenuHeader_style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var Header = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-a0a4a467-0"
})(MenuHeader_style_templateObject());
var HeaderContainer = (0,styled_components_browser_esm/* default */.ZP)(lib.Container).withConfig({
    componentId: "sc-a0a4a467-1"
})(MenuHeader_style_templateObject1(), globals/* color.charcoal03 */.$.charcoal03);
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a0a4a467-2"
})(MenuHeader_style_templateObject2());
var Left = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a0a4a467-3"
})(MenuHeader_style_templateObject3());
var Right = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a0a4a467-4"
})(MenuHeader_style_templateObject4());
var LogoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a0a4a467-5"
})(MenuHeader_style_templateObject5(), (0,styled_breakpoints.down)("md"));

;// CONCATENATED MODULE: ./src/components/Common/Header/MenuHeader/MenuHeader.tsx







var MenuHeader = function(param) {
    var onChangeLanguage = param.onChangeLanguage, language = param.language, showSwitchLanguage = param.showSwitchLanguage, menus = param.menus, content = param.content;
    var ref = (0,react.useState)(false), subMenuVisible = ref[0], setSubMenuVisible = ref[1];
    var availableLanguage = content === null || content === void 0 ? void 0 : content.supportedLangs.map(function(lang) {
        return lang.code;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
        style: {
            width: subMenuVisible ? "100vw" : "100%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Left, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoContainer, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SundayLogo/* default */.Z, {
                                    content: {
                                        headerLogoLink: content === null || content === void 0 ? void 0 : content.headerLogoLink,
                                        headerLogoImageUrl: "https://static.easysunday.com/retail/artifacts/sunday-logo.svg"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenu_MainMenu, {
                                subMenuVisible: subMenuVisible,
                                setSubMenuVisible: setSubMenuVisible,
                                menus: menus
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Right, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.LanguageSwitcher, {
                                availableLanguages: availableLanguage,
                                showSwitch: showSwitchLanguage,
                                onChangeLanguage: onChangeLanguage,
                                language: language
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileMainMenu/* default */.Z, {
                                availableLanguage: availableLanguage,
                                showSwitch: showSwitchLanguage,
                                onChangeLanguage: onChangeLanguage,
                                language: language,
                                menus: menus
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var MenuHeader_MenuHeader = (MenuHeader);


/***/ })

}]);